import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { fetchBoxes } from '../actions'
import ShowBoxes from '../components/boxes/ShowBoxes';


 const propTypes = {
  dispatch: PropTypes.func.isRequired,
}

 class BoxesPage extends React.Component {
  constructor(){
    super();
    autoBind(this);
  }

   getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount(){
    this.props.dispatch(fetchBoxes())
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="boxes component" style={authPage}>
        <ShowBoxes />
      </div>
    );
  }
}


 BoxesPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

 BoxesPage.propTypes = propTypes;

 export default connect()(BoxesPage);


// WEBPACK FOOTER //
// ./src/containers/BoxesPage.js